export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "zones.worker.ba65cc9b29750ec4b21e.worker.js");
}
